export default __webpack_public_path__ + "static/media/847.97d81139.png";